const avatarComponent = ({ imageSrc, alt, height, width }) => {

  return (
    <img src={imageSrc || "/images/logo/logo.png"} className="attachment-medium size-medium post-image border" alt={alt} />
  );
};

export default avatarComponent;